module.exports = __webpack_public_path__ + "img/pms_5.5616a407.png";